import { render, staticRenderFns } from "./StartupsAccessLevelsChart.vue?vue&type=template&id=149f1b59"
import script from "./StartupsAccessLevelsChart.vue?vue&type=script&lang=js"
export * from "./StartupsAccessLevelsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports